/**
 * @generated SignedSource<<af1358320e28a690095a64de046b4ee3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type TransactionType = "NEGOTIABLE" | "NON_NEGOTIABLE" | "OFF_PLATFORM" | "PRE_AUTH_NEGOTIATION" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type checkoutPaneReducer_preCheckoutTransaction$data = {
  readonly hasPartialShippingAddress: boolean | null;
  readonly isAuctionOrderType: boolean | null;
  readonly isWireTransfer: boolean | null;
  readonly shipment: {
    readonly shippingAddress: {
      readonly sourceId: string | null;
    } | null;
  } | null;
  readonly shipmentQuotes: ReadonlyArray<{
    readonly serviceId: string | null;
  } | null> | null;
  readonly transactionType: TransactionType | null;
  readonly " $fragmentType": "checkoutPaneReducer_preCheckoutTransaction";
};
export type checkoutPaneReducer_preCheckoutTransaction$key = {
  readonly " $data"?: checkoutPaneReducer_preCheckoutTransaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutPaneReducer_preCheckoutTransaction">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutPaneReducer_preCheckoutTransaction"
};

(node as any).hash = "ba60e0c1accd240e1c97bb13b09d2373";

export default node;
